import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgInfoOutline = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-info-outline';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M11.393 4.282A7.85 7.85 0 0 0 7.1 6c-.382.314-1.038.996-1.307 1.361-1.118 1.512-1.669 3.403-1.52 5.209.06.726.164 1.233.391 1.905a7.8 7.8 0 0 0 1.128 2.164c.263.356.96 1.08 1.327 1.38.912.743 2.179 1.342 3.341 1.579a8.1 8.1 0 0 0 3.08 0c1.162-.237 2.429-.836 3.341-1.579.367-.3 1.064-1.024 1.327-1.38 1.116-1.512 1.672-3.417 1.518-5.209a7.3 7.3 0 0 0-.392-1.91c-.405-1.204-1.032-2.186-1.979-3.101-1.328-1.282-2.957-2.004-4.828-2.139a11 11 0 0 0-.627-.034zm1.743 1.578c2.522.462 4.533 2.479 5.01 5.025.098.521.098 1.709 0 2.23a6.7 6.7 0 0 1-.853 2.195c-.514.808-1.278 1.566-2.04 2.024a6.9 6.9 0 0 1-2.019.793c-.355.078-.531.091-1.234.091-.705 0-.879-.013-1.24-.092-1.292-.281-2.353-.867-3.24-1.792a6.1 6.1 0 0 1-1.437-2.356c-.241-.721-.3-1.111-.3-1.978s.059-1.257.3-1.978A6.24 6.24 0 0 1 9.22 6.42a6.5 6.5 0 0 1 1.875-.599c.507-.073 1.542-.053 2.041.039m-1.887 2.89.011.75h1.48l.011-.75.011-.75h-1.524zm-.009 4.75V16h1.52v-5h-1.52z"
    })
  }));
});
export default SvgInfoOutline;